export default __webpack_public_path__ + "static/media/Badge Workspace.c7bb3fc6.png";